import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  GridModule
} from '@progress/kendo-angular-grid';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {AgmJsMarkerClustererModule} from '@agm/js-marker-clusterer';
import {AgmCoreModule} from '@agm/core';
import {FlexLayoutModule} from '@angular/flex-layout';
import {EditorModule} from '@progress/kendo-angular-editor';
import {MatExpansionModule} from '@angular/material/expansion';
import {CurateComponent} from './curate.component';
import {SharedCommonModule} from '../shared/common';
import {ConfirmDialogComponent} from '../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {TreeViewModule} from '@progress/kendo-angular-treeview';
import {FloatingLabelModule} from '@progress/kendo-angular-label';
import {SortableModule} from '@progress/kendo-angular-sortable';
import {LoadingIndicatorModule} from '../shared/layout/components/loading-indicator';
import {TooltipModule} from '@progress/kendo-angular-tooltip';

@NgModule({
  declarations: [
    CurateComponent
  ],
  imports: [
    ButtonsModule,
    GridModule,
    DateInputsModule,
    DropDownsModule,
    FloatingLabelModule,
    LoadingIndicatorModule,
    SortableModule,
    TooltipModule,
    InputsModule,
    EditorModule,
    MatExpansionModule,
    TreeViewModule,
    SharedCommonModule,
    AgmCoreModule,
    AgmJsMarkerClustererModule,
    FlexLayoutModule
  ],
  providers: [
  ],
  entryComponents: [
    ConfirmDialogComponent
  ],
})
export class CurateModule {
}
